// extracted by mini-css-extract-plugin
export default {"tupacGrid":"jl-z","tupacHeader":"kl-z","tupacHeader2":"ll-z","tupacMenu":"ml-z","tupacMenu2":"nl-z","tupacMain":"ol-z","tupacMain2":"pl-z"};